import { Injectable } from '@angular/core';
import { init, send, EmailJSResponseStatus } from '@emailjs/browser';
import { ContactFormData, TalentFormData } from '../models/DigitalKit';


@Injectable({
  providedIn: 'root'
})
export class EmailService {


  private publicKey = 'ALAU0xRp6j64rZ_WC';
  private serviceId = 'service_pvefz84';


  private templateContact = 'template_rvxk0ky';
  private templateTalent = 'template_ikea8b8';

  constructor() {
    init(this.publicKey);
  }


  sendContactForm(data: ContactFormData): Promise<EmailJSResponseStatus> {
    return send(this.serviceId, this.templateContact, data);
  }


  sendTalentForm(data: TalentFormData): Promise<EmailJSResponseStatus> {
    return send(this.serviceId, this.templateTalent, data);
  }
}
